import React from 'react'
import { Chip } from '@material-ui/core'
import './TagOptionSelected.scss'

export const TagOptionSelected = ({ label, getTagProps, index }) => {
  return (
    <div className='option-tag-selected'>
      <Chip
        label={label}
        {...getTagProps({ index })}
        deleteIcon={<span>×</span>}
      />
    </div>

  )
}
